export const ItemStatus = {
  Pending: "Pending",
  Delivered: "Delivered",
  Cancelled: "Cancelled",
};

export enum LeagueLevel {
  Low = 1,
  Intermediate = 2,
  High = 3,
}

export enum ULTRA_SERVICE_LOCATION_ENUM {
  MAGIC_CITY = 1,
  AVENTURA,
  BRICKBELL,
}
